export const EVENT_COLORS_HEX = [
  "#ef4444", "#f97316", "#f59e0b", "#10b981", "#3b82f6", "#6366f1", "#8b5cf6", "#ec4899"
];

export const getEventColor = (id: string) => {
  if (!id) return EVENT_COLORS_HEX[0];
  let hash = 0;
  for (let i = 0; i < id.length; i++) {
    hash = id.charCodeAt(i) + ((hash << 5) - hash);
  }
  return EVENT_COLORS_HEX[Math.abs(hash) % EVENT_COLORS_HEX.length];
};
